import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import axios from "axios";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

const FechaMetodos = () => {
  //variables
  const { handleSubmit, register, setValue } = useForm();
  const [limitDay, setLimitDay] = useState("");

  //funciones
  useEffect(() => {
    getLimitDay();
  }, []);

  const getLimitDay = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_date`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      // console.log(response.data.data[0].limit_day)

      setLimitDay(response.data.data[0].limit_day);
      setValue("dateMetodos", response.data.data[0].limit_day);
    } catch (error) {
      console.error(error);
    }
  };

  const sendDate = async (data) => {
    // console.log(data)
    try {
      const body = {
        limit_day: data.dateMetodos,
      };
      const response = await axios.put(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/payment_date/update`,
        body,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      // console.log(response)

      Swal.fire({
        title: "Fecha actualizada con éxito",
        icon: "success",
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <ScrollToTop />
      <div className="row justify-content-center">
        <div className="col col-md-6">
          <form
            onSubmit={handleSubmit(sendDate)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <div className="text-premium-blue font-semibold">
              <p>Día límite</p>
            </div>
            <select
              className="form-select"
              aria-label="Default select example"
              id="dateMetodos"
              {...register("dateMetodos", {
                required: true,
              })}
              defaultValue={limitDay}
            >
              <option selected>Seleciona día límite</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
              <option value="24">24</option>
              <option value="25">25</option>
              <option value="26">26</option>
              <option value="27">27</option>
              <option value="28">28</option>
              <option value="29">29</option>
              <option value="30">30</option>
              <option value="31">31</option>
            </select>
            <div className="mt-3 d-flex justify-content-end">
              <button
                type="submit"
                className="col col-md-2 btn-amc-blue mt-3 mt-md-0 ml-2"
              >
                Finalizar
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FechaMetodos;
